"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draftTypeSchema = void 0;
const zod_1 = require("zod");
exports.draftTypeSchema = zod_1.z.enum(["open", "versionHistory", "temporary"]);
